"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asResponsiveIframe = exports.asBaseResponsiveIframe = void 0;

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var ActivatorWrapper = fclasses_1.addClasses('absolute w-full h-full inset-0')(fclasses_1.Div);
var asBodilessIframe = core_1.asBodilessComponent(__assign(__assign({}, components_1.useIframeBodilessOptions()), {
  Wrapper: ActivatorWrapper
}));
var asBaseResponsiveIframe = fclasses_1.withDesign({
  Item: lodash_1.flowRight(fclasses_1.replaceWith(lodash_1.flowRight(core_1.ifEditable(components_1.withoutPointerEvents), asBodilessIframe())(fclasses_1.Iframe)))
});
exports.asBaseResponsiveIframe = asBaseResponsiveIframe;
var asResponsiveIframe = fclasses_1.withDesign({
  Item: lodash_1.flowRight(fclasses_1.replaceWith(lodash_1.flowRight(core_1.ifEditable(components_1.withoutPointerEvents), asBodilessIframe(), components_1.withIframeFormHeader, components_1.withIframeFormSrcSnippet)(fclasses_1.Iframe)))
});
exports.asResponsiveIframe = asResponsiveIframe;